<template>
    <!-- Componente criado no kb 58598 -->
     
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12 sm10 md8 lg6>
                <v-card elevation="10" class="pa-4">
                    
                    <v-img 
                        src="@/assets/logo_nrmemories.png"
                        contain 
                        height="80px"
                        class="logo"
                    />

                    <div
                        class="terms-container"
                        style="max-height: 70vh; overflow-y: auto; background-color: #EBEBEB; padding: 10px;"
                        v-html="termsOfUse"
                    >
                        HTML HARDCODED AQUI
                    </div>

                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import api from '@/services/api'
    export default {
        name: 'TermsOfUse',
        mounted() {
            document.title = 'NR Memories - Termos de Uso';
            this.loadTermsOfUse();
            this.teste()
        },

        data(){
            return {
                termsOfUse: ''
            }
        },

        methods: {
            async loadTermsOfUse () {

                try {
                    const response = await api.get('/public/terms-of-use');

                    this.termsOfUse = response.data.content;

                } catch (error) {
                    console.error(error);

                    this.termsOfUse = 'Erro ao carregar termos.';
                }
            },

            async teste () {

                try {
                    await api.get('/public/terms-of-use/teste');

                } catch (error) {
                    console.error(error);
                }
            }
        }
    }
</script>